




























import Vue, { PropType } from "vue";
import { EventSummary } from "../types";
import EventDetails from "@/components/EventDetails.vue";

export default Vue.extend({
  name: "ProcessGroup",
  components: {
    EventDetails,
  },
  props: {
    summary: Object as PropType<EventSummary>,
    timeRangeQuery: Object,
  },
  data: () => {
    return {
      expand: false,
    };
  },
});
